import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ModalComponent } from 'components/modal/modal.component';
import { Perfil } from 'src/app/shared/enums/Perfis/Perfis';
import { ListarChamados } from 'src/app/shared/models/chamados/listar-chamados';
import { PlanoContingencia } from "src/app/shared/models/plano-contingencia/plano-contingencia";
import { PlanoMelhoria } from "src/app/shared/models/plano-melhoria/planoMelhoria";
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-modal-notificacoes-alert',
    templateUrl: './modal-notificacoes-alert.component.html',
    styleUrls: ['./modal-notificacoes-alert.component.scss'],
    standalone: true,
    imports:[ModalComponent,CommonModule, RouterModule]
})
export class ModalNotificacoesAlertComponent {
  public readonly Perfil = Perfil;

  @Input() chamadosAtrasados: ListarChamados[] = [];
  @Input() planosContingenciaPendentes: PlanoContingencia[] = [];
  @Input() semPlanosContingenciaPendentesDiretor: boolean = false;
  @Input() planosMelhoriaPendentes: PlanoMelhoria[] = [];
  @Input() semPlanosMelhoriaPendentesDiretor: boolean = false;
  @Input() planosContingenciaAjustes: PlanoContingencia[] = [];
  @Input() planosMelhoriaAjustes: PlanoMelhoria[] = [];
  @Input() planosContingenciaAguardandoSupervisor: PlanoContingencia[] = [];
  @Input() planosMelhoriaAguardandoSupervisor: PlanoMelhoria[] = [];
  @Input() showModalNotificacao = false;
  @Input() mensagemNotificacao: string[] = [];
  @Input() perfil: number = 0;
  /** Contagens de validação (Supervisor / PEC); 0 quando não aplicável. */
  @Input() contagemPlanoContingenciaValidacao = 0;
  @Input() contagemPmceValidacao = 0;

  private perfisQuePodemVisualizarChamadosPendentes: Perfil[] = [
    Perfil.GestorConviva,
    Perfil.PEC,
    Perfil.POC,
    Perfil.DiretorEscolar,
    Perfil.ViceDiretor,
    Perfil.Dirigente,
    Perfil.SupervisorEducacional];

  private perfisQuePodemVisualizarChamadosComAgendamentosAtrasados: Perfil[] = [
    Perfil.GestorConviva,
    Perfil.PEC,
    Perfil.Dirigente,
    Perfil.Psicólogo,
    Perfil.CoordenadorPsicologo,
    Perfil.FiscalPsicologo];

  private perfisQuePodemVisualizarChamadosAguardandoAtendimento: Perfil[] = [
    Perfil.GestorConviva,
    Perfil.PEC,
    Perfil.POC,
    Perfil.DiretorEscolar,
    Perfil.ViceDiretor,
    Perfil.Dirigente,
    Perfil.Psicólogo,
    Perfil.CoordenadorPsicologo,
    Perfil.FiscalPsicologo];

  private perfisQuePodemVisualizarChamadosAguardandoEncerramento: Perfil[] = [
    Perfil.GestorConviva,
    Perfil.PEC,
    Perfil.POC,
    Perfil.DiretorEscolar,
    Perfil.ViceDiretor,
    Perfil.Dirigente,
    Perfil.SupervisorEducacional,
    Perfil.FiscalPsicologo ];

  public perfisQuePodemVerOModal:Perfil[] = [...this.perfisQuePodemVisualizarChamadosPendentes,
    ...this.perfisQuePodemVisualizarChamadosComAgendamentosAtrasados,
    ...this.perfisQuePodemVisualizarChamadosAguardandoAtendimento,
    ...this.perfisQuePodemVisualizarChamadosAguardandoEncerramento];

  isShaking = false;
  totalChamadosAtrasados = 0;


  public get podeVisualizarCountChamadosPendentes(): boolean {
    return this.countChamadoPorStatus('Pendente análise do chamado') > 0 &&
     this.validPermissionToView(this.perfisQuePodemVisualizarChamadosPendentes);
  }

  public get podeVisualizarCountChamadosAtrasadoAgendamento(): boolean {
     return this.countChamadoPorStatus('Atrasado Agendamento do Psicólogo') > 0 &&
      this.validPermissionToView(this.perfisQuePodemVisualizarChamadosComAgendamentosAtrasados);
  }

  public get podeVisualizarCountChamadosAtrasadoAtendimento(): boolean {
    return this.countChamadoPorStatus('Aguardando Atendimento do Psicólogo') > 0 &&
    this.validPermissionToView(this.perfisQuePodemVisualizarChamadosAguardandoAtendimento);
  }

  public get podeVisualizarCountChamadosAguardandoEncerramento(): boolean {
    return this.countChamadoPorStatus('Aguardando Encerramento') > 0 &&
    this.validPermissionToView(this.perfisQuePodemVisualizarChamadosAguardandoEncerramento);
  }

  public get exibirPlanoContingenciaPendente(): boolean {
    // PEC não valida mais Plano de Contingência — sem alerta de pendência de PC
    return false;
  }

  public get exibirPlanoContingenciaPendenteDiretor(): boolean {
    return this.perfil === Perfil.DiretorEscolar && this.semPlanosContingenciaPendentesDiretor;
  }

  public get exibirPlanoMelhoriaPendente(): boolean {
    return (
      (this.perfil === Perfil.PEC &&
        (this.contagemPmceValidacao > 0 || (this.planosMelhoriaPendentes?.length ?? 0) > 0)) ||
      this.mensagemNotificacao.length > 0
    );
  }

  public get exibirPlanoMelhoriaPendenteDiretor(): boolean {
    return this.perfil === Perfil.DiretorEscolar && this.semPlanosMelhoriaPendentesDiretor;
  }

  public get exibirPlanoContingenciaParaAjustarDiretor(): boolean {
    return (this.perfil === Perfil.DiretorEscolar || this.perfil === Perfil.ViceDiretor)
      && (this.planosContingenciaAjustes?.length ?? 0) > 0;
  }

  public get exibirPmceParaAjustarDiretor(): boolean {
    return (this.perfil === Perfil.DiretorEscolar || this.perfil === Perfil.ViceDiretor)
      && (this.planosMelhoriaAjustes?.length ?? 0) > 0;
  }

  public get exibirPlanoContingenciaParaValidarSupervisor(): boolean {
    return (
      this.perfil === Perfil.SupervisorEducacional &&
      (this.contagemPlanoContingenciaValidacao > 0 ||
        (this.planosContingenciaAguardandoSupervisor?.length ?? 0) > 0)
    );
  }

  public get exibirPmceParaValidarSupervisor(): boolean {
    return (
      this.perfil === Perfil.SupervisorEducacional &&
      (this.contagemPmceValidacao > 0 || (this.planosMelhoriaAguardandoSupervisor?.length ?? 0) > 0)
    );
  }

  public get visualizarModalPsicologo(): boolean{

   const totalChamados = this.countChamadoPorStatus('Atrasado Agendamento do Psicólogo') + this.countChamadoPorStatus('Aguardando Atendimento do Psicólogo');

   return (this.perfil ==  Perfil.Psicólogo
    || this.perfil == Perfil.DiretorEscolar) && totalChamados > 0;
  }


  public GetTotalChamadosAtrasados(){
    let totalDeChamados = 0;
    if(this.podeVisualizarCountChamadosPendentes){
      totalDeChamados += this.countChamadoPorStatus('Pendente análise do chamado');
    }


    if(this.podeVisualizarCountChamadosAtrasadoAgendamento){
      totalDeChamados += this.countChamadoPorStatus('Atrasado Agendamento do Psicólogo');
    }
    if(this.podeVisualizarCountChamadosAtrasadoAtendimento){
      totalDeChamados += this.countChamadoPorStatus('Aguardando Atendimento do Psicólogo');
    }
    if(this.podeVisualizarCountChamadosAguardandoEncerramento){
      totalDeChamados += this.countChamadoPorStatus('Aguardando Encerramento');
    }


    return totalDeChamados;


  }




  countChamadoPorStatus(sla: string) {
    return this.chamadosAtrasados.filter(x => x.aluno?.dsStatusEnvolvido == sla).length;
  }




  public triggerShake() {
    this.isShaking = true;
    // Remove a classe após a duração da animação para reutilização
    setTimeout(() => {
      this.isShaking = false;
    }, 1500);
  }
  public openModalNotificacao() {
    this.showModalNotificacao = true;
    this.triggerShake();
  }

  public closeModalNotificacao() {
    this.showModalNotificacao = false;
    this.totalChamadosAtrasados = 0;
  }



  public validPermissionToView(roles: number[]): boolean {
    if(!this.visualizarModalPsicologo){
      return false;
    }

    return roles.includes(this.perfil);
  }





}
